import { Component, Input } from '@angular/core';
import { ScansInterface } from '@monsido/modules/models/api/interfaces/scans.interface';

@Component({
    selector: 'mon-request-checker-cookies-component',
    templateUrl: 'cookies.html',
    styleUrls: ['./../../request-checker.scss'],
    standalone: false,
})

export class CookiesComponent {
    @Input() url: string;
    @Input() scan: ScansInterface;
    constructor () {}
}
